module.exports = __webpack_public_path__ + "static/media/Raising.56c5d211.png";